export default "__VITE_ASSET__CkcmC67$__"